import React from 'react';
import { Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { unitResponsesStyles } from './styles';
import { unitLabel } from '@common/services/unitUtils';

const VcmUnitCode = ({ classes, row }) => {
  const isActive = row.unit?.active;
  return (
    <div className={classes.cell}>
      <Typography
        className={classes.body2}
        style={{ textDecoration: isActive ? 'none' : 'line-through' }}
      >
        {unitLabel(row.unit)}
      </Typography>
    </div>
  );
};

export default withStyles(VcmUnitCode, unitResponsesStyles, {
  withTheme: true
});
